/**
 * AuthBrandImage — shared logo image for auth pages (Login, Signup, VerifyEmail).
 * Renders logo-large.png at a fixed 48px height; callers extend via styled() for
 * page-specific margin spacing.
 */

import styled from 'styled-components';

export const AuthBrandImage = styled.img.attrs({
  src: '/assets/logo-large.png',
  alt: 'ABA Insights',
})`
  height: 48px;
  width: auto;
  display: block;
`;
